import type { CustomerCapability, DestekMe } from "@mbbe/types";

export type PortalCapability = CustomerCapability;

export type PortalCustomerProfile = DestekMe;

const capabilityAliases: Record<PortalCapability, string[]> = {
  dashboard: ["dashboard", "portal.dashboard"],
  support: ["support", "portal.support"],
  tasks: ["tasks", "portal.tasks"],
  payments: ["payments", "portal.payments"],
  commercial: ["commercial", "portal.commercial"],
  reports: ["reports", "portal.reports"],
  files: ["files", "portal.files"],
  documentation: ["documentation", "portal.documentation"],
  meetings: ["meetings", "portal.meetings"],
  approvals: ["approvals", "portal.approvals"],
};

export function hasPortalCapability(profile: PortalCustomerProfile | null, capability: PortalCapability): boolean {
  if (!profile) return false;
  if (!profile.access) return true;
  const granted = new Set<string>(profile.access.capabilities);
  return capabilityAliases[capability].some((value) => granted.has(value));
}

export function hasPortalProjectGrant(profile: PortalCustomerProfile | null, projectId: string | null): boolean {
  if (!projectId || !profile?.access) return true;
  return profile.access.allProjects || profile.access.projectIds.includes(projectId);
}

export function portalMemberName(profile: PortalCustomerProfile | null): string {
  return profile?.member?.displayName || profile?.displayName || profile?.member?.email || profile?.email || "";
}

export function portalOrganizationName(profile: PortalCustomerProfile | null): string {
  return profile?.organization?.name || profile?.companyName || "";
}

export function isActivePortalProfile(profile: PortalCustomerProfile): boolean {
  return profile.role === "customer" && profile.member?.status !== "disabled";
}
